import { createContext, FC, ReactNode, useContext } from "react";

const ShareTokenContext = createContext<string | null>(null);

const ShareTokenProvider: FC<{ children: ReactNode; token: string }> = ({
  children,
  token,
}) => (
  <ShareTokenContext.Provider value={token}>
    {children}
  </ShareTokenContext.Provider>
);

const useShareToken = () => useContext(ShareTokenContext);

export { ShareTokenProvider, useShareToken };
